<mat-toolbar class="content-header">
    <mat-toolbar-row class="toolbar-row">
        <h1 class="page-title">
            <mat-icon fontIcon="analytics"></mat-icon>
            {{'title.reports' | translate}}
        </h1>

        <span class="toolbar-spacer"></span>

        <div class="tab-menu">
            <!-- Target button -->
            <lib-button *ngIf="target()" icon="gps_fixed" color="danger" text="{{'events.deleteTarget' | translate}}" (click)="clearTarget()"></lib-button>

            <!-- Date-picker / Range-picker -->
            <div class="toolbar-section date-navigation">
                <div class="date-picker">
                    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_left"
                        (click)="navigateDate(-1)">
                    </lib-button>

                    <app-date-picker *ngIf="!showEndDate" [startDate]="startDate" [min]="currentProject()?.createdDate"
                        (dateChanged)="onDatePickerChanged($event)" [hideTime]="true" [activity]="activitySignal()">
                    </app-date-picker>

                    <app-range-picker *ngIf="showEndDate" [startDate]="startDate" [endDate]="endDate"
                        (change)="onRangePickerChanged($event)" [activity]="activitySignal()">
                    </app-range-picker>

                    <lib-button *ngIf="!showEndDate" size="small" color="none" icon="date_range"
                        (click)="onShowEndChange()" tooltip="{{ 'dashboard.enable_date_range' | translate }}">
                    </lib-button>

                    <lib-button *ngIf="showEndDate" size="small" color="none" icon="close" (click)="onShowEndChange()">
                    </lib-button>

                    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_right"
                        (click)="navigateDate(1)" [disabled]="!canNavigateNext">
                    </lib-button>
                </div>
            </div>

            <!-- Mode selection buttons -->
            <lib-button *ngIf="mode == 'timeline'" [matMenuTriggerFor]="menu" icon="timeline">
            </lib-button>

            <lib-button *ngIf="mode == 'list'" [matMenuTriggerFor]="menu" icon="view_list">
            </lib-button>

            <lib-button *ngIf="mode == 'tags'" [matMenuTriggerFor]="menu" icon="insert_photo">
            </lib-button>

            <lib-button *ngIf="mode == 'calendar'" [matMenuTriggerFor]="menu" icon="date_range">
            </lib-button>

            <!-- Menus -->
            <mat-menu #menu="matMenu" class="modern-menu">
                <button mat-menu-item (click)="setMode('timeline')" class="menu-item">
                    <mat-icon class="icon">timeline</mat-icon>
                    {{ 'Timeline' }}
                </button>

                <button mat-menu-item (click)="setMode('list')" class="menu-item">
                    <mat-icon class="icon">view_list</mat-icon>
                    {{ 'risks.list_mode' | translate }}
                </button>

                <button mat-menu-item (click)="setMode('tags')" class="menu-item">
                    <mat-icon class="icon">insert_photo</mat-icon>
                    {{ 'Coups de grue' }}
                </button>

                <button mat-menu-item (click)="setMode('calendar')" class="menu-item">
                    <mat-icon class="icon">date_range</mat-icon>
                    {{ 'Calendrier de séquence' }}
                </button>
            </mat-menu>

            <mat-form-field appearance="outline" class="select-tag" *ngIf="mode=='tags'" subscriptSizing="dynamic"
                @slideInOut>
                <mat-label *ngIf="!selectedTag">
                    {{ 'events.tags.select' | translate }}
                </mat-label>

                <mat-select [(value)]="selectedTag" (selectionChange)="onSelectedTagChange($event.value)">
                    <mat-option [value]="'default'">
                        {{ 'events.tags.select' | translate }}
                    </mat-option>

                    <mat-option [value]="'Non défini'">
                        {{ 'events.tags.not_defined' | translate }}
                    </mat-option>

                    <mat-option *ngFor="let tag of craneTags" [value]="tag.name">
                        {{ tag.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Menu options -->
            <lib-button [matMenuTriggerFor]="timelineMenu" color="muted" icon="more_horiz">
            </lib-button>

            <mat-menu #timelineMenu="matMenu">
                <div class="mat-menu-content">
                    <ng-container *ngIf="mode != 'tags' && mode != 'calendar'">
                        <mat-slide-toggle [(ngModel)]="singleTimeline" class="slider"
                            (change)="onShowUniqueTimelineChange($event.checked)">
                            {{'dashboard.unique_timeline' | translate }}
                        </mat-slide-toggle>

                        <ng-container *ngIf="currentProject()?.metricModels && currentProject()?.metricModels?.length">
                            <button mat-menu-item (click)="addMetric()">
                                <mat-icon class="icon-addM">trending_up</mat-icon>
                                {{ 'events.metric_add'| translate }}
                            </button>
                        </ng-container>

                        <!-- Bouton si metricModels n'existe pas ou est vide -->
                        <ng-container
                            *ngIf="!currentProject()?.metricModels || !currentProject()?.metricModels?.length">
                            <button mat-menu-item (click)="configureMetricModels()">
                                <mat-icon class="icon-addM">settings</mat-icon>
                                <span class="text-metric">{{ 'events.metric_configure_models'| translate }}</span>
                            </button>
                        </ng-container>

                        <button mat-menu-item [matMenuTriggerFor]="metricsMenu">
                            {{ "events.metrics" | translate }}
                        </button>

                        <button mat-menu-item [matMenuTriggerFor]="eventTypesMenu">
                            {{ "events.events" | translate }}
                        </button>

                        <button mat-menu-item [matMenuTriggerFor]="timelinesMenu">
                            Timelines
                        </button>
                    </ng-container>
                </div>
            </mat-menu>

            <mat-menu #metricsMenu="matMenu">
                <button mat-menu-item (click)="$event.stopPropagation()" class="menu-btn">
                    <mat-checkbox class="checkbox full-width-checkbox" color="accent"
                        [checked]="areAllSelected(metricTypes, selectedMetricTypes$)"
                        [indeterminate]="isIndeterminate(metricTypes, selectedMetricTypes$)"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelectAll($event, metricTypes, selectedMetricTypes$)">
                        {{ areAllSelected(metricTypes, selectedMetricTypes$) ? ("events.deselectAll" | translate) :
                        ("events.selectAll" | translate) }}
                    </mat-checkbox>
                </button>

                <button mat-menu-item (click)="$event.stopPropagation()" *ngFor="let type of metricTypes"
                    class="menu-item-checkbox">
                    <mat-checkbox class="checkbox full-width-checkbox" color="primary"
                        [checked]="selectedMetricTypes$.value.includes(type)" (click)="$event.stopPropagation()"
                        (change)="onMetricTypeChanged($event, type)">
                        {{ type }}
                    </mat-checkbox>
                </button>
            </mat-menu>

            <mat-menu #eventTypesMenu="matMenu">
                <button mat-menu-item (click)="$event.stopPropagation()" class="menu-btn">
                    <mat-checkbox class="checkbox full-width-checkbox" color="accent"
                        [checked]="areAllSelected(eventTypes, selectedEventTypes$)"
                        [indeterminate]="isIndeterminate(eventTypes, selectedEventTypes$)"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelectAll($event, eventTypes, selectedEventTypes$)">
                        {{ areAllSelected(eventTypes, selectedEventTypes$) ? ("events.deselectAll" | translate) :
                        ("events.selectAll" | translate) }}
                    </mat-checkbox>
                </button>

                <button mat-menu-item (click)="$event.stopPropagation()" *ngFor="let type of eventTypes"
                    class="menu-item-checkbox">
                    <mat-checkbox class="checkbox full-width-checkbox" color="primary"
                        [checked]="selectedEventTypes$.value.includes(type)" (click)="$event.stopPropagation()"
                        (change)="onEventTypeChanged($event, type)">
                        {{ type | convertEvent | translate }}
                    </mat-checkbox>
                </button>
            </mat-menu>

            <mat-menu #timelinesMenu="matMenu">
                <div *ngIf="this.noData" class="noDataTimeline">
                    {{'events.no_timeline' | translate}}
                </div>

                <button mat-menu-item (click)="$event.stopPropagation()" *ngFor="let res of availableResources"
                    class="menu-item-checkbox">
                    <mat-checkbox color="primary" class="checkbox full-width-checkbox" [checked]="res.show"
                        (click)="$event.stopPropagation()"
                        (change)="onTimelineResourceChanged($event, res)">
                        {{res.name}}
                    </mat-checkbox>
                </button>
            </mat-menu>

            <!-- Search bar -->
            <app-search-bar (searchText)="search($event)"></app-search-bar>
        </div>
    </mat-toolbar-row>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<app-spinner *ngIf="loading" fill></app-spinner>

<ng-container *ngIf="!loading">
    <ng-container *ngIf="!noData && mode=='timeline'">
        <div class="timeline-list" *ngIf="!singleTimeline">
            <ng-container *ngFor="let resource of availableResources">
                <ng-container *ngIf="resource.show">
                    <h2 *ngIf="resource.type=='user'" class="timeline-title">
                        <mat-icon fontIcon="person" matTooltip="User"></mat-icon>
                        {{'users.title' | translate}}
                    </h2>

                    <h2 *ngIf="resource.type=='unit'" class="timeline-title">
                        <mat-icon fontIcon="devices_other" matTooltip="{{'units.unit' | translate}}"></mat-icon>
                        {{resource.name}}
                    </h2>

                    <h2 *ngIf="resource.type=='tracker'" class="timeline-title">
                        <mat-icon fontIcon="track_changes" matTooltip="{{'trackers.title' | translate}}"></mat-icon>
                        {{resource.name}}
                    </h2>

                    <app-timeline [timelineData]="timelineData" [eventTypes$]="selectedEventTypes$"
                        [search]="validSearchText" [metricTypes$]="selectedMetricTypes$" [startDate]="startDate"
                        [endDate]="endDate" [tracker]="resource.trackerObj" [trackers]="resource.trackers"
                        [unit]="resource.unitObj" [singleTimeline]="singleTimeline"
                        [timelineUpdateSignal]="timelineUpdateSignal" [target]="target">
                    </app-timeline>
                </ng-container>
            </ng-container>
        </div>

        <div class="timeline-list" *ngIf="singleTimeline">
            <ng-container>
                <h2 class="timeline-title">
                    <mat-icon fontIcon="devices_other"></mat-icon>
                    {{'trackers.allTrackers' | translate}}
                </h2>

                <app-timeline [timelineData]="timelineData" [eventTypes$]="selectedEventTypes$"
                    [metricTypes$]="selectedMetricTypes$" [startDate]="startDate" [endDate]="endDate"
                    [search]="validSearchText" [availableResources]="(availableResources$ | async) || []"
                    [singleTimeline]="singleTimeline" [timelineUpdateSignal]="timelineUpdateSignal" [target]="target">
                </app-timeline>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="mode=='list'">
        <app-event-list [search]="validSearchText" [eventTypes$]="selectedEventTypes$" [unitTypes$]="selectedResources$"
            [trackerTypes$]="selectedTrackerTypes$" [metricTypes$]="selectedMetricTypes$" [startDate]="startDate"
            [endDate]="endDate"></app-event-list>
    </ng-container>

    <ng-container *ngIf="mode=='calendar'">
        <app-sequence-calendar [startDate]="startDate" [endDate]="endDate"></app-sequence-calendar>
    </ng-container>

    <ng-container *ngIf="mode=='tags'">
        <app-crane-cycles [search]="validSearchText" [unitTypes$]="selectedResources$"
            [trackerTypes$]="selectedTrackerTypes$" [dateObs]="datesUpdater$" [selectedTagObs]="selectedTag$"
            [availableResources]="availableResources" [trackers]="trackers">
        </app-crane-cycles>
    </ng-container>

    <ng-container *ngIf="noData && (mode =='timeline')">
        <lib-no-data></lib-no-data>
    </ng-container>
</ng-container>